import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const contactSupportApi = createApi({
  reducerPath: 'contactSupportApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['contactSupport'],
  endpoints: (builder) => ({
    addQueryContact: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.contactSupportController.addQueryContact}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteQueryContact: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.contactSupportController.deleteQueryContact}${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    findAllQueryContact: builder.mutation({
      query(body) {
        return {
          url: spotFinder.contactSupportController.findAllQueryContact,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
   
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddQueryContactMutation,
  useDeleteQueryContactMutation,
  useFindAllQueryContactMutation,
} = contactSupportApi;
